export const DON_VI_TINH_PERMISSION_CODES = {
  WEB_BH_DON_VI_TINH_LIST: 'WEB_BH_DON_VI_TINH_LIST',
  WEB_BH_DON_VI_TINH_ADD: 'WEB_BH_DON_VI_TINH_ADD',
  WEB_BH_DON_VI_TINH_EDIT: 'WEB_BH_DON_VI_TINH_EDIT',
  WEB_BH_DON_VI_TINH_DELETE: 'WEB_BH_DON_VI_TINH_DELETE',
  WEB_BH_DON_VI_TINH_IMPORT: 'WEB_BH_DON_VI_TINH_IMPORT',
  WEB_BH_DON_VI_TINH_EXPORT: 'WEB_BH_DON_VI_TINH_EXPORT',
} as const
